import React from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Login from "./components/login/Login";
import ChangePasswaord from "./components/changePassword/ChangePasswaord";
import Home from "./components/home/Home";
import RequestTracking from "./components/requestTracking/RequestTraking";
import RequestTracking_3D from "./components/requestTracking/requestTrackPrinting/RequestTracking_3D";
import RequestTracking_360 from "./components/requestTracking/requestTrackPrinting/RequestTracking_360";
import Footer from "./components/footer/Footer";

import { useSelector } from "react-redux";

const App = () => {
  const { user } = useSelector((state) => state.auth);

  return (
    <>
      <div className="App" style={{ minHeight: "86vh" }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reset-password/:id" element={<ChangePasswaord />} />
          <Route path="/login" element={<Login />} />
          <Route path="/requests" element={<RequestTracking />} />
          <Route path="/request_3D/:id" element={<RequestTracking_3D />} />
          <Route path="/request_360/:id" element={<RequestTracking_360 />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
};

export default App;
